import React, { FC } from "react";
import { LinkCard } from "@tvg/design-system/web";
import { TopPool } from "@tvg/ts-types/Pool";
import { UnaryFn } from "@tvg/ts-types/Functional";
import { QA_LABEL } from "../../../qaLabels";
import { CardContainer, PoolItemContainer } from "./styled-components";
import MtpValue from "../../MtpValue";
import AmountValue from "../../AmountValue";

interface TopPoolCardProps {
  topPool: TopPool;
  index: number;
  isOnWide: boolean;
  onPoolClick: UnaryFn<TopPool, void>;
}

const TopPoolCard: FC<TopPoolCardProps> = ({
  topPool,
  index,
  isOnWide,
  onPoolClick
}) => {
  const linkCard = (
    <LinkCard
      key={`${topPool.trackCode}-${topPool.race.raceNumber}-${topPool.race.postTime}-${index}`}
      startContent={
        <PoolItemContainer>
          <MtpValue race={topPool.race} />
        </PoolItemContainer>
      }
      endContent={
        <PoolItemContainer>
          <AmountValue amount={topPool.amount} />
        </PoolItemContainer>
      }
      title={`${topPool.track} R${topPool.race.raceNumber}`}
      description={topPool.wagerType.name}
      onPress={() => onPoolClick(topPool)}
      qaLabel={QA_LABEL.body.desktop.pool}
    />
  );

  return isOnWide ? (
    <CardContainer isOnWide={isOnWide}>{linkCard}</CardContainer>
  ) : (
    linkCard
  );
};

export default TopPoolCard;
